import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function LeakRemoveIcon(props: IconProps) {
    return <Icon {...props} iconKey={"leak_remove"}/>
}
